import { render, staticRenderFns } from "./disclaimerPage.vue?vue&type=template&id=005980c2&"
import script from "./disclaimerPage.vue?vue&type=script&lang=js&"
export * from "./disclaimerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports